import { CommonModule } from '@angular/common';
import { Component, ElementRef, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { I18nModule } from '@spartacus/core';
import { Option } from '../../../../../../core/models/option.model';
import { TooltipModule } from 'primeng/tooltip';
import { ItemEntry } from '../../../core/quotes.model';
import { NgxMaskDirective } from 'ngx-mask';
import { FormsModule } from '@angular/forms';
import { ScreenViewModule } from '../../../../../../core/directives/screen-view/_screen-view.module';
import { DEVICE_SIZE } from '../../../../../../core/models/others.model';

@Component({
  selector: '[quote-item]',
  standalone: true,
  imports: [CommonModule, I18nModule, TooltipModule, NgxMaskDirective, FormsModule, ScreenViewModule],
  templateUrl: './quote-item.component.html',
  styleUrl: './quote-item.component.scss',
})
export class QuoteListItemComponent implements OnInit {
  @ViewChild('reqPrice', { static: true }) reqPrice!: ElementRef;

  @Input() entry!: ItemEntry;
  @Input() frequencies!: Option[];
  @Output() _onChange = new EventEmitter<ItemEntry>();
  @Output() _onRemoveProduct = new EventEmitter<ItemEntry>();

  DEVICE_SIZE = DEVICE_SIZE;

  ngOnInit(): void {
    setTimeout(() => {
      this.reqPrice.nativeElement.value = this.entry.reqPrice;
      const event = new Event('input', { bubbles: true });
      this.reqPrice.nativeElement.dispatchEvent(event);
    }, 0);
  }

  setQty(qty: string) {
    const entry: ItemEntry = {
      ...this.entry,
      ...{ qty: parseInt(qty) },
    };

    this.edit(entry);
  }

  setFrequency(frequency: string) {
    const entry: ItemEntry = {
      ...this.entry,
      ...{ frequency: frequency },
    };

    this.edit(entry);
  }

  setReqPrice(reqPrice: string) {
    const entry: ItemEntry = {
      ...this.entry,
      ...{ reqPrice },
    };

    this.edit(entry);
  }

  edit(entry: ItemEntry) {
    this._onChange.emit(entry);
  }

  removeProduct(entry: ItemEntry) {
    this._onRemoveProduct.emit(entry);
  }
}
